import { RepositoryFactory } from "@/Apicall/RepositoryFactory";
const author = RepositoryFactory.get("author");
export default {
  createAuthor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log(payload, "payload");
        const { data } = await author.CreateAuthor(payload)

        commit("CREATE_AUTHOR", data.data);


        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getAllAuthor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await author.getAllAuthor(payload)

        commit("GET_AUTHOR_DATA", data.data);


        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  getAllAuthorList({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await author.getAllAuthorList(payload)

        commit("GET_AUTHOR_DATA_LIST", data.data);


        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  updateAuthor({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await author.EditAuthor(payload)
        resolve(data)
      } catch (err) {
        console.log(err)
        reject(err)
      }
    })
  }
};